























































































































import dayjs from 'dayjs';
import { DT_FORMAT_INPUT, MONTH_FORMAT } from '../../../src_server/common/momentExtends';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { PaymentTeacherService } from '../../biz/remote/PaymentTeacherService';
import { FBRecordDTO } from '../../../src_server/entity/dto/FBRecordDTO';
import { DataRecord } from '../../../src_server/entity/dto/DataRecord';
import SortTh from '../../components/atoms/SortTh.vue';
import { Sorter } from '../../utils/Sorter';
import NoDataPanel from '../../components/atoms/NoDataPanel.vue';
import { URIs } from '../../../src_server/common/URIs';
import Axios from 'axios';
import { Session } from '../../utils/Session';
import { MessageDialog } from '../../utils/MessageDialog';

@Component({
  components: { SortTh, NoDataPanel },
  filters: {
    to_currency: (num: number) => {
      return num.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
    },
    to_hours: (num: number) => {
      return `${Math.round(num * 100) / 100} 時間`;
    },
    to_minute: (num: number) => {
      return `${num} 分`;
    },
  },
})
export default class PaymentTeacherPage extends Vue {
  private value: FBRecordDTO = new FBRecordDTO();

  private month = dayjs().format(MONTH_FORMAT);

  get sumAmount() {
    return this.value.data.filter((d) => d.selected).reduce((a, c) => a + c.furikomi_kingaku, 0);
  }
  get sumCount() {
    return this.value.data.filter((d) => d.selected).length;
  }
  get sumLessonCount() {
    return this.value.data.filter((d) => d.selected).reduce((a, c) => a + c.lesson_count, 0);
  }

  private target_date_: Date = new Date();
  private get target_date() {
    return this.target_date_;
  }
  private set target_date(value: Date) {
    this.target_date_ = value;
    this.value.header.furikomi_date = dayjs(value).format('MMDD');
  }

  checked(row: DataRecord, event: any) {
    if (row.hasError) {
      MessageDialog.alert(`データにエラーが存在するため対象にできません。`).then();
      event.target.checked = false;
      row.selected = false;
      return;
    }
    row.is_target = event.target.checked;
    row.selected = event.target.checked;
  }

  defaultChecked(row: DataRecord) {
    row.selected = !!row.is_target && !row.hasError;
    return !!row.is_target && !row.hasError;
  }
  nextMonth() {
    this.month = dayjs(this.month).add(1, 'month').format(MONTH_FORMAT);
  }
  currentMonth() {
    this.month = dayjs().format(MONTH_FORMAT);
  }
  prevMonth() {
    this.month = dayjs(this.month).add(-1, 'month').format(MONTH_FORMAT);
  }

  get header() {
    return this.value.header;
  }

  get record() {
    return this.value.data;
  }

  get trailer() {
    return this.value.trailer;
  }

  get end() {
    return this.value.end;
  }

  @Watch('month')
  async loadData() {
    const biz = new PaymentTeacherService();
    const response = await biz.getFBDataByMonth(dayjs(this.month).format(DT_FORMAT_INPUT), Session.getSessionBuildingId(), '', '');
    this.value = response.data;
    this.value.header.furikomi_date = dayjs(this.target_date).format('MMDD');
  }

  async created() {
    this.loadData();
  }

  sortBy(up: boolean, target: any) {
    // console.log(up, target, Sorter.compareByPath(target, up));
    this.value.data = this.record.sort(Sorter.compareByPath(target, up));
  }
  checkAll() {
    this.value.data.forEach((d) => (d.is_target = true));
  }
  offAll() {
    this.value.data.forEach((d) => (d.is_target = false));
  }
  async outCSV() {
    const selected_user_ids = this.value.data.filter((d) => this.defaultChecked(d)).map((d) => d.user_id);
    const url = `${URIs.PAYMENT_CSV_DOWNLOAD.path}?month=${this.month}&building_id=${Session.getSessionBuildingId()}&selected=${selected_user_ids.join(',')}&target_date=${
      this.value.header.furikomi_date
    }&token=${Session.getJwtToken()}`;
    // const response = await Axios.get(url);
    // console.log('tes', response.data);
    location.href = url;
  }
}
